<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              how_to_reg
            </v-icon>
            <span class="title">
              Data <span v-if="detaildata" class="text-capitalize">{{ detaildata.jenisdata }} </span> <b>{{ nikdata }}</b>
            </span>
            <v-spacer></v-spacer>
            <v-btn
              :to="{ name: 'PendudukAdmin' }"
              color="error"
              icon
              x-small>
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="center" v-if="loading.detail">
                <v-col cols="12">
                  <div class="text-center">
                    <v-progress-circular
                      :width="3"
                      color="red"
                      indeterminate>
                    </v-progress-circular>
                  </div>
                </v-col>
              </v-row>
              <v-row justify="center" v-if="detaildata && !loading.detail">
                <v-col cols="12" md="7" class="text-justify">
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <v-card
                        :color="maincolor"
                        dark
                        raised>
                        <v-card-title class="title py-3">Data Diri</v-card-title>
                        <v-card-text class="white text--primary py-3">
                          <v-list light>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Jenis Data</v-list-item-title>
                                <v-list-item-subtitle class="text-capitalize">{{ detaildata.jenisdata }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-content>
                                <v-list-item-title>Cabang Olahraga</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.cabang_olga }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>NIK</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.nik }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-content>
                                <v-list-item-title>Nama</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.nama }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Status Menikah</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.status_menikah }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-content>
                                <v-list-item-title>Tempat / Tanggal Lahir</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.tempat_lahir }} / {{ detaildata.tanggal_lahir }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Jenis Kelamin</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.kelamin | kelaminParse }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-content>
                                <v-list-item-title>Agama</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.agama }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Pendidikan</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.pendidikan }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-content>
                                <v-list-item-title>Pekerjaan</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.pekerjaan }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Email</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.email }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-content>
                                <v-list-item-title>Telepone</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.phone }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <v-card
                        :color="maincolor"
                        dark
                        raised>
                        <v-card-title class="title py-3">Data Alamat</v-card-title>
                        <v-card-text class="white text--primary py-3">
                          <v-list light>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Kabupaten/Kota</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.kab_ktp }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-content>
                                <v-list-item-title>Kecamatan</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.kec_ktp }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Kelurahan/Desa</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.kel_ktp }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-content>
                                <v-list-item-title>Banjar</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.banjar_ktp }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Jalan</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.alamat }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-content>
                                <v-list-item-title>Kode Pos</v-list-item-title>
                                <v-list-item-subtitle>{{ detaildata.pos_ktp }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <v-card
                        :color="maincolor"
                        dark
                        raised>
                        <v-card-title class="title py-3">Data Prestasi</v-card-title>
                        <v-card-text class="white text--primary py-3">
                          <v-data-table
                            light
                            :headers="headers"
                            :items="listprestasi"
                            :search="filter.search">
                            <template v-slot:[`item.action`]="{ item }">
                              <v-btn
                                @click="editJenisolga(item)"
                                small
                                icon>
                                <v-icon>edit</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                          <div class="mt-2">
                            <v-btn
                              @click="addPrestasi"
                              color="primary"
                              small>
                              <v-icon left>add</v-icon> Prestasi
                            </v-btn>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <v-card
                        :color="maincolor"
                        dark
                        raised>
                        <v-card-title class="title py-3">Berkas KTP</v-card-title>
                        <v-card-text class="white text--primary py-3">
                          <div class="mt-2">
                            <v-img
                              :src="detaildata.urlktp"
                              aspect-ratio="1.7">
                            </v-img>
                            <a class="mt-3" :href="detaildata.urlktp" target="_blank">Download KTP</a>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="5" class="pl-md-10">
                  <v-form
                    class="text-center"
                    ref="formupdateavatar"
                    v-model="formadd.avatar"
                    lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-avatar
                          max-width="100%"
                          size="120"
                          color="red">
                          <img
                            v-if="detaildata.urlavatar"
                            :src="detaildata.urlavatar"
                            :alt="detaildata.nama">
                          <span
                            v-if="!detaildata.urlavatar"
                            class="white--text headline">
                            {{ detaildata.initial }}
                          </span>
                        </v-avatar>
                      </v-col>
                      <v-col cols="12">
                        <v-file-input
                          v-model="changeavatar.file_avatar"
                          :rules="rules.files"
                          :append-outer-icon="formadd.avatar ? 'mdi-send' : 'not_interested'"
                          accept="image/png, image/jpeg, image/bmp"
                          placeholder="Pick an avatar"
                          prepend-icon="mdi-camera"
                          label="Avatar"
                          show-size
                          @click:append-outer="changeAvatar">
                        </v-file-input>
                      </v-col>
                    </v-row>
                  </v-form>
                  <v-form
                    ref="formupdatedata"
                    v-model="formadd.valid"
                    lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          :items="listjenidata"
                          name="jenisdata"
                          v-model="detaildata.jenisdata"
                          label="Jenis Data *">
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="detaildata.cabang_olga"
                          :items="listolga"
                          item-value="nama_olga"
                          item-text="nama_olga"
                          label="Cabang Olahraga"
                          :rules="[rules.required]">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.nik"
                          label="NIK *"
                          name="nik">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="detaildata.nama"
                          :rules="[rules.required]"
                          label="Nama *"
                          name="nama"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          :items="liststatus"
                          name="status"
                          v-model="detaildata.status_menikah"
                          label="Status *">
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="detaildata.tempat_lahir"
                          label="Tempat lahir *"
                          :rules="[rules.required]"
                          name="tempatlahir"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-menu
                          v-model="datepick.tgllahir"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="detaildata.tanggal_lahir"
                              label="Tanggal lahir *"
                              readonly
                              v-on="on">
                            </v-text-field>
                          </template>
                          <v-date-picker
                            ref="birthday"
                            :max="datepick.date"
                            name="tgllahir"
                            v-model="detaildata.tanggal_lahir"
                            @input="datepick.tgllahir = false">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          :items="listkelamin"
                          name="kelamin"
                          v-model="detaildata.kelamin"
                          label="Jenis kelamin">
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          :items="listagama"
                          v-model="detaildata.agama"
                          name="agama"
                          label="Agama">
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          :items="listpendidikan"
                          name="pendidikan"
                          v-model="detaildata.pendidikan"
                          label="Pendidikan">
                        </v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="detaildata.pekerjaan"
                          name="pekerjaan"
                          label="Pekerjaan"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="detaildata.email"
                          label="E-mail"
                          name="email"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="detaildata.phone"
                          label="Telephone *"
                          name="telephone"
                          :rules="[rules.phone]"
                          :counter="14"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-divider></v-divider>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.status_ver"
                          label="Status Verifikasi">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" v-if="detaildata.status_ver === 'ya'">
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.tgl_ver"
                          label="Tanggal Verifikasi">
                        </v-text-field>
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.user_ver"
                          label="Oleh">
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <alertsp :alertdata="alertdata"></alertsp>
                    <v-row>
                      <v-col cols="12">
                        <v-btn
                          large
                          block
                          :disabled="!formadd.valid"
                          color="success"
                          class="mr-4 mt-5"
                          @click="submitUpdate">
                          Simpan
                        </v-btn>
                        <v-btn
                          large
                          block
                          :disabled="!formadd.valid || detaildata.status_ver === 'ya'"
                          :color="detaildata.status_ver === 'tidak' ? 'error' : ''"
                          class="mr-4 mt-5"
                          @click="verifikasiUpdate">
                          Verifikasi
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - add -->
    <v-dialog
      v-model="dmodal.addprestasi"
      max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Tambah data prestasi</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-form
              @submit.prevent="submitAddPrestasi"
              ref="formaddprestasi"
              v-model="formaddprestasi.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-select
                        :items="listyear"
                        :rules="[rules.required]"
                        name="tahun"
                        v-model="dmodaldata.addprestasi.tahun_prestasi"
                        label="Tahun Prestasi">
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        :items="listjuara"
                        :rules="[rules.required]"
                        name="juara"
                        v-model="dmodaldata.addprestasi.juara_prestasi"
                        label="Juara Prestasi">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="listtingkat"
                        :rules="[rules.required]"
                        name="tingkat"
                        v-model="dmodaldata.addprestasi.tingkat_prestasi"
                        label="Tingkat Prestasi">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.addprestasi.deskripsi_prestasi"
                        :rules="[rules.required]"
                        label="Deskripsi Prestasi"
                        name="deskripsi"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-file-input
                        v-model="dmodaldata.addprestasi.file_prestasi"
                        :rules="rules.files"
                        accept="image/png, image/jpeg, image/bmp"
                        placeholder="Pilih file"
                        prepend-icon="mdi-camera"
                        label="Upload sertifikat"
                        show-size>
                      </v-file-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <alertsp :alertdata="alertadd"></alertsp>
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="closeDmodal('addprestasi')">
                        Cancel
                      </v-btn>
                      <v-btn
                        large
                        :disabled="!formaddprestasi.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- modal - edit -->
    <v-dialog
      v-model="dmodal.editprestasi"
      max-width="600px"
      v-if="dmodaldata.editprestasi">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Tambah data prestasi</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-form
              @submit.prevent="submitEditPrestasi"
              ref="formeditprestasi"
              v-model="formeditprestasi.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-select
                        :items="listyear"
                        :rules="[rules.required]"
                        name="tahun"
                        v-model="dmodaldata.editprestasi.tahun_prestasi"
                        label="Tahun Prestasi">
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        :items="listjuara"
                        :rules="[rules.required]"
                        name="juara"
                        v-model="dmodaldata.editprestasi.juara_prestasi"
                        label="Juara Prestasi">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="listtingkat"
                        :rules="[rules.required]"
                        name="tingkat"
                        v-model="dmodaldata.editprestasi.tingkat_prestasi"
                        label="Tingkat Prestasi">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.editprestasi.deskripsi_prestasi"
                        :rules="[rules.required]"
                        label="Deskripsi Prestasi"
                        name="deskripsi"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-img
                        :src="dmodaldata.editprestasi.urlimg"
                        aspect-ratio="1.7">
                      </v-img>
                    </v-col>
                    <v-col cols="12">
                      <v-file-input
                        v-model="dmodaldata.editprestasi.file_prestasinew"
                        accept="image/png, image/jpeg, image/bmp"
                        placeholder="Pilih file"
                        prepend-icon="mdi-camera"
                        label="Upload sertifikat"
                        show-size>
                      </v-file-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <alertsp :alertdata="alertadd"></alertsp>
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="closeDmodal('editprestasi')">
                        Cancel
                      </v-btn>
                      <v-btn
                        large
                        :disabled="!formeditprestasi.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getDateTodayId } from '../../utils/dateFormatCustom.js';
import { mapState } from 'vuex';

export default {
  name: 'SuratDetailAdmin',
  props: ['kodesurat'],
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertadd: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      avatar: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    nikdata: '',
    detaildata: null,
    listyear: [],
    listolga: [],
    listjuara: ['1', '2', '3'],
    listtingkat: ['Internasional', 'Nasional', 'Provinsi', 'Kabupaten', 'Kecamatan'],
    listjenidata: ['atlet', 'pelatih'],
    liststatus: ['Belum Menikah', 'Menikah', 'Cerai'],
    listkelamin: ['L', 'P'],
    listagama: ['Hindu', 'Budha', 'Kristen', 'Katolik', 'Islam', 'Other'],
    listpendidikan: ['SD', 'SLTP', 'SLTA', 'D1', 'D2', 'D3', 'D4', 'S1', 'S2', 'S3', 'Tidak Sekolah'],
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      tgllahir: false,
    },
    updatesurat: {
      deskripsi_surat: '',
      status_surat: '',
      kode_surat: '',
      no_surat: '',
    },
    changeavatar: {
      file_avatar: null,
    },
    verifikasi: {
      nik: '',
      status: 'tidak',
    },
    formadd: {
      valid: false,
      avatar: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 8 || 'Min 8 characters',
      nik: (v) => v.length === 16 || 'Min 16 characters',
      phone: (v) => (!!v && v.length <= 15) || 'Max 15 characters',
      email: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      files: [
        (value) => !value || value.size < 1000000 || 'File kurang dari 1 MB!',
      ],
    },
    urlprint: '',
    filter: {
      search: '',
    },
    headers: [
      { text: 'Tahun', value: 'tahun_prestasi' },
      { text: 'Juara', value: 'juara_prestasi' },
      { text: 'Tingkat', value: 'tingkat_prestasi' },
      { text: 'Keterangan', value: 'deskripsi_prestasi' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    listprestasi: [],
    formaddprestasi: {
      valid: false,
    },
    formeditprestasi: {
      valid: false,
    },
    dmodal: {
      addprestasi: false,
      editprestasi: false,
    },
    dmodaldata: {
      addprestasi: {
        tahun_prestasi: '',
        juara_prestasi: '',
        tingkat_prestasi: '',
        deskripsi_prestasi: '',
        file_prestasi: null,
      },
      editprestasi: null,
    },
  }),
  watch: {
    '$route.query.nik'(val) {
      if (val) {
        this.nikdata = val;
        this.getDetailPenduduk();
      }
    },
    'datepick.tgllahir'(val) {
      if (val) {
        setTimeout(() => (this.$refs.birthday.activePicker = 'YEAR'));
      }
    },
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'useremail',
    ]),
  },
  mounted() {
    if (this.$route.query.nik) {
      this.nikdata = this.$route.query.nik;
      this.getDetailPenduduk();
    }
    this.getListYear();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
    dateToIndo(value) {
      return getDateTodayId(value);
    },
    kelaminParse(value) {
      return value === 'L' ? 'Laki-Laki' : 'Perempuan';
    },
  },
  methods: {
    getListYear() {
      this.listyear = [];
      const rangeYear = 5;
      const currentYear = new Date().getFullYear();
      for (let i = 0; i < rangeYear; i++) {
        this.listyear.push(currentYear - i);
      }
      this.dmodaldata.addprestasi.tahun_prestasi = this.listyear[0];
    },
    getInitial(str) {
      let retstr = '';
      if (str) {
        retstr = str.match(/\b(\w)/g);
        retstr = retstr.join('');
      }
      return retstr;
    },
    closeDmodal(type) {
      if (type === 'addprestasi') {
        this.dmodal.addprestasi = false;
      } else if (type === 'editprestasi') {
        this.dmodal.editprestasi = false;
      } else {
        this.dmodal.addprestasi = false;
      }
    },
    addPrestasi() {
      this.dmodal.addprestasi = true;
    },
    changeAvatar() {
      if (this.changeavatar.file_avatar) {
        this.loading.avatar = true;
        this.changeavatar.nik = this.detaildata.nik;
        this.changeavatar.avatar_old = this.detaildata.file_avatar;
        if (this.tokenscr) {
          const dataadd = this.changeavatar;
          const formData = new FormData();
          // file image
          formData.append('file_avatar', dataadd.file_avatar);
          // data olga
          formData.append('nik', dataadd.nik);
          formData.append('avatar_old', dataadd.avatar_old);
          this.axios
            .post(
              this.api + '/api/penduduk/avatar',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formupdateavatar.reset();
                  this.detaildata.urlavatar = this.api + '/upload/avatar/' + resdata.data.name;
                  this.detaildata.file_avatar = resdata.data.name;
                } else {
                  console.log(resdata.message);
                }
              } else {
                console.log('Internal services error!');
              }
              this.loading.avatar = false;
            })
            .catch((error) => {
              console.log('Internal services error!');
              this.loading.avatar = false;
            });
        } else {
          console.log('Invalid token!');
          this.loading.avatar = false;
        }
      }
    },
    getOlga() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jenisolga/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listolga = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getDetailPenduduk() {
      if (this.tokenscr) {
        this.loading.detail = true;
        this.axios
          .get(
            this.api + '/api/penduduk/' + this.nikdata,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.detaildata = resdata.data[0];
                // this.updatesurat.kode_surat = resdata.data[0].kode_surat;
                // this.updatesurat.deskripsi_surat = resdata.data[0].deskripsi_surat;
                // this.updatesurat.status_surat = resdata.data[0].status_surat;
                // this.urlprint = this.api + '/public/penduduk/' + this.nikdata + '/' + resdata.data[0].no_kk;
                this.detaildata.initial = this.getInitial(resdata.data[0].nama);
                if (resdata.data[0].file_avatar) {
                  this.detaildata.urlavatar = this.api + '/upload/avatar/' + resdata.data[0].file_avatar;
                } else {
                  this.detaildata.urlavatar = false;
                }
                this.detaildata.urlktp = this.api + '/upload/media/' + resdata.data[0].file_ktp;
                this.getPrestasi();
                this.getOlga();
              }
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
          });
      }
    },
    getPrestasi() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/prestasi/' + this.detaildata.nik,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listprestasi = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    submitAddPrestasi() {
      this.alertadd.show = false;
      if (this.$refs.formaddprestasi.validate()) {
        if (this.tokenscr) {
          const dataadd = this.dmodaldata.addprestasi;
          const formData = new FormData();
          formData.append('tahun_prestasi', dataadd.tahun_prestasi);
          formData.append('juara_prestasi', dataadd.juara_prestasi);
          formData.append('tingkat_prestasi', dataadd.tingkat_prestasi);
          formData.append('deskripsi_prestasi', dataadd.deskripsi_prestasi);
          formData.append('file_prestasi', dataadd.file_prestasi);
          // send data
          this.axios
            .post(
              this.api + '/api/prestasi/' + this.detaildata.nik,
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddprestasi.reset();
                  this.alertadd.show = true;
                  this.alertadd.type = 'success';
                  this.alertadd.text = 'Prestasi "' + resdata.data.deskripsi + '" berhasil ditambahkan!';
                  this.getPrestasi();
                } else {
                  this.alertadd.show = true;
                  this.alertadd.type = 'error';
                  this.alertadd.text = resdata.message;
                }
              } else {
                this.alertadd.show = true;
                this.alertadd.type = 'error';
                this.alertadd.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertadd.show = true;
              this.alertadd.type = 'error';
              this.alertadd.text = 'Internal services error!';
            });
        } else {
          this.alertadd.show = true;
          this.alertadd.type = 'error';
          this.alertadd.text = 'Invalid token!';
        }
      }
    },
    verifikasiUpdate() {
      this.alertdata.show = false;
      this.verifikasi.nik = this.detaildata.nik;
      this.verifikasi.status = 'ya';
      if (this.$refs.formupdatedata.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/penduduk/verifikasi',
              qs.stringify(
                this.verifikasi,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Verifikasi "' + this.verifikasi.nik + '" berhasil dilakukan!';
                  this.getDetailPenduduk();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    submitUpdate() {
      this.alertdata.show = false;
      if (this.$refs.formupdatedata.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/penduduk/',
              qs.stringify(
                this.detaildata,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Data penduduk "' + this.detaildata.nik + '" berhasil diperbaharui!';
                  this.getDetailPenduduk();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    editJenisolga(item) {
      this.dmodal.editprestasi = true;
      item.tahun_prestasi = parseInt(item.tahun_prestasi, 10);
      item.urlimg = this.api + '/upload/prestasi/' + item.file_prestasi;
      this.dmodaldata.editprestasi = JSON.parse(JSON.stringify(item));
    },
    submitEditPrestasi() {
      this.alertadd.show = false;
      if (this.$refs.formeditprestasi.validate()) {
        if (this.tokenscr) {
          const dataadd = this.dmodaldata.editprestasi;
          const formData = new FormData();
          formData.append('atlet_prestasi', dataadd.atlet_prestasi);
          formData.append('tahun_prestasi', dataadd.tahun_prestasi);
          formData.append('juara_prestasi', dataadd.juara_prestasi);
          formData.append('tingkat_prestasi', dataadd.tingkat_prestasi);
          formData.append('deskripsi_prestasi', dataadd.deskripsi_prestasi);
          formData.append('file_prestasiold', dataadd.file_prestasi);
          formData.append('file_prestasi', dataadd.file_prestasinew);
          // send data
          this.axios
            .post(
              this.api + '/api/prestasi/edit/' + dataadd.id_prestasi,
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertadd.show = true;
                  this.alertadd.type = 'success';
                  this.alertadd.text = 'Prestasi "' + resdata.data.deskripsi + '" berhasil diupdate!';
                  this.getPrestasi();
                } else {
                  this.alertadd.show = true;
                  this.alertadd.type = 'error';
                  this.alertadd.text = resdata.message;
                }
              } else {
                this.alertadd.show = true;
                this.alertadd.type = 'error';
                this.alertadd.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertadd.show = true;
              this.alertadd.type = 'error';
              this.alertadd.text = 'Internal services error!';
            });
        } else {
          this.alertadd.show = true;
          this.alertadd.type = 'error';
          this.alertadd.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss'>
  table.tbl-more-p5{
    td{
      padding-left: 5px;
      padding-right: 5px;
    }
  }
  .text-underline{
    text-decoration: underline;
  }
  .border-solid-thin{
    border: solid thin #f1f1f1;
  }
</style>
